"use strict";
// Copyright 2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
var ScreenSignalingSessionEventType;
(function (ScreenSignalingSessionEventType) {
    ScreenSignalingSessionEventType["Close"] = "close";
    ScreenSignalingSessionEventType["StreamStart"] = "streamstart";
    ScreenSignalingSessionEventType["StreamEnd"] = "streamend";
    ScreenSignalingSessionEventType["StreamSwitch"] = "streamswitch";
    ScreenSignalingSessionEventType["Heartbeat"] = "heartbeat";
})(ScreenSignalingSessionEventType = exports.ScreenSignalingSessionEventType || (exports.ScreenSignalingSessionEventType = {}));
exports.default = ScreenSignalingSessionEventType;
//# sourceMappingURL=ScreenSignalingSessionEventType.js.map